<div class="col-12" id="RehabInnerContainer" style="border:1px solid black;border-radius:3px;">
    <p>Please fill in dollar amounts for all of the applicable items being rehabbed. CK Capital needs an accurate rehab dollar figure on file, we also require an additional 20% contingency to compensate for possible rehab unknowns. Your contingency value is <strong>{{rehabTotal * .2 | currency}}</strong></p>
    <p *ngIf="totalBudgetAllocated != rehabTotal" style="font-size:24px">Total rehab/construction budget you've allocated so far=<span style="color:red;font-weight: bold;">{{totalBudgetAllocated | currency}}</span>, remaining needing allocated=<span style="color:red;font-weight:bold">{{rehabTotal - totalBudgetAllocated | currency}}</span></p>
    <p *ngIf="totalBudgetAllocated == rehabTotal" style="font-size:24px">Total rehab/construction budget you've allocated so far=<span style="color:green;font-weight: bold;">{{totalBudgetAllocated | currency}}</span>, remaining needing allocated=<span style="color:green;font-weight:bold">{{rehabTotal - totalBudgetAllocated | currency}}</span></p>
    <p-accordion>
        <p-accordionTab header="Permits/Site Improvement (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Plans & Architect </label>
                  <input type="number" [(ngModel)]="rehabItems.plans_and_architect" (keyup)="onChange()" pInputText />
                </div>
            </div>
            <div class="col-12 sm:col-6 md:col-4">
              <div class="input_fields">
                <label>Structural Engineer Report </label>
                <input type="number" [(ngModel)]="rehabItems.structural_engineer_report" pInputText />
              </div>
            </div>
            <div class="col-12 sm:col-6 md:col-4">
              <div class="input_fields">
                <label>Engineer Report </label>
                <input type="number" [(ngModel)]="rehabItems.engineer_report" pInputText />
              </div>
            </div>
          
            <div class="col-12 sm:col-6 md:col-4">
              <div class="input_fields">
                <label>Perc Test </label>
                <input type="number" [(ngModel)]="rehabItems.perc_test" pInputText />
              </div>
            </div>
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Certifications (asbestos, mold, etc.) </label>
                  <input type="number" [(ngModel)]="rehabItems.asbestos_mold_certifications" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Temporary Power </label>
                  <input type="number" [(ngModel)]="rehabItems.temporary_power" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Survey </label>
                  <input type="number" [(ngModel)]="rehabItems.survey" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Temporary Utilities </label>
                  <input type="number" [(ngModel)]="rehabItems.temporary_utilities" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Erosion Control </label>
                    <input type="number" [(ngModel)]="rehabItems.erosion_control" pInputText />
                  </div>
                </div>

                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Septic Permit </label>
                    <input type="number" [(ngModel)]="rehabItems.septic_permit" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Well Permit </label>
                    <input type="number" [(ngModel)]="rehabItems.well_permit" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Electric Permit </label>
                    <input type="number" [(ngModel)]="rehabItems.electric_permit" pInputText />
                  </div>
                </div>

                <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Plumbing Permit </label>
                      <input type="number" [(ngModel)]="rehabItems.plumbing_permit" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Foundation Permit </label>
                      <input type="number" [(ngModel)]="rehabItems.foundation_permit" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Roof Permit </label>
                      <input type="number" [(ngModel)]="rehabItems.roof_permit" pInputText />
                    </div>
                  </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Interior Design </label>
                  <input type="number" [(ngModel)]="rehabItems.interior_design" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Building Permit </label>
                  <input type="number" [(ngModel)]="rehabItems.building_permit" pInputText />
                </div>
              </div>
            </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Onsite Work (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Excavate/Backfill </label>
                  <input type="number" [(ngModel)]="rehabItems.excavate_backfill" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Import/Export Dirt </label>
                  <input type="number" [(ngModel)]="rehabItems.import_export_dirt" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Soil Treatment </label>
                  <input type="number" [(ngModel)]="rehabItems.soil_treatment" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Gas line </label>
                  <input type="number" [(ngModel)]="rehabItems.gas_line" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Gas Materials </label>
                    <input type="number" [(ngModel)]="rehabItems.gas_materials" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Gas Labor </label>
                    <input type="number" [(ngModel)]="rehabItems.gas_labor" pInputText />
                  </div>
                </div>

                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Well Install/Replacement </label>
                    <input type="number" [(ngModel)]="rehabItems.well_install_replacement" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Water Line - Public </label>
                    <input type="number" [(ngModel)]="rehabItems.water_line_public" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Foundation Material </label>
                      <input type="number" [(ngModel)]="rehabItems.foundation_material" pInputText />
                    </div>
                  </div>

                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Foundation Labor </label>
                      <input type="number" [(ngModel)]="rehabItems.foundation_labor" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Structural Steel </label>
                      <input type="number" [(ngModel)]="rehabItems.structural_steel" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Water Proofing </label>
                      <input type="number" [(ngModel)]="rehabItems.water_proofing" pInputText />
                    </div>
                  </div>
                
                  <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Equipment Rental </label>
                        <input type="number" [(ngModel)]="rehabItems.equipment_rental" pInputText />
                      </div>
                    </div>
                    <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Drainage </label>
                        <input type="number" [(ngModel)]="rehabItems.drainage" pInputText />
                      </div>
                    </div>
                  </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Site Improvements (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Fencing Material </label>
                  <input type="number" [(ngModel)]="rehabItems.fencing_material" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Fencing Labor </label>
                  <input type="number" [(ngModel)]="rehabItems.fencing_labor" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Pool </label>
                  <input type="number" [(ngModel)]="rehabItems.pool" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Pool Hardscape </label>
                  <input type="number" [(ngModel)]="rehabItems.pool_hardscape" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Landscaping </label>
                    <input type="number" [(ngModel)]="rehabItems.landscaping" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Utilities </label>
                    <input type="number" [(ngModel)]="rehabItems.utilities" pInputText />
                  </div>
                </div>

                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Driveway </label>
                    <input type="number" [(ngModel)]="rehabItems.driveway" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Utility Dig </label>
                    <input type="number" [(ngModel)]="rehabItems.utility_dig" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Other </label>
                      <input type="number" [(ngModel)]="rehabItems.other_onsite_work" pInputText />
                    </div>
                  </div>
                </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Demo (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Exterior Demo </label>
                  <input type="number" [(ngModel)]="rehabItems.exterior_demo" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Interior Demo </label>
                  <input type="number" [(ngModel)]="rehabItems.interior_demo" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Other Demo </label>
                  <input type="number" [(ngModel)]="rehabItems.other_demo" pInputText />
                </div>
              </div>
            </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Exterior (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Roof (repair/replace) </label>
                  <input type="number" [(ngModel)]="rehabItems.roof_repair_replace" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Siding 1 </label>
                  <input type="number" [(ngModel)]="rehabItems.siding_1" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Siding 2 </label>
                  <input type="number" [(ngModel)]="rehabItems.siding_2" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Siding 3 </label>
                  <input type="number" [(ngModel)]="rehabItems.siding_3" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Siding 4 </label>
                    <input type="number" [(ngModel)]="rehabItems.siding_4" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Paint Exterior </label>
                    <input type="number" [(ngModel)]="rehabItems.paint_exterior" pInputText />
                  </div>
                </div>

                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Trim/Sofit/Fascia </label>
                    <input type="number" [(ngModel)]="rehabItems.trim_sofit_fascia" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Features (trim) </label>
                    <input type="number" [(ngModel)]="rehabItems.features_trim" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Gutters/Downspouts </label>
                      <input type="number" [(ngModel)]="rehabItems.gutters_downspouts" pInputText />
                    </div>
                  </div>

                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Garage/Doors </label>
                      <input type="number" [(ngModel)]="rehabItems.garage_doors" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Doors - Exterior </label>
                      <input type="number" [(ngModel)]="rehabItems.exterior_doors" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Doors - Hardware </label>
                      <input type="number" [(ngModel)]="rehabItems.exterior_door_hardware" pInputText />
                    </div>
                  </div>

                  <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Front Port/Portico </label>
                        <input type="number" [(ngModel)]="rehabItems.front_port_portico" pInputText />
                      </div>
                    </div>
                    <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Rear Deck/Porch/Stairs </label>
                        <input type="number" [(ngModel)]="rehabItems.rear_deck_porch_stairs" pInputText />
                      </div>
                    </div>
                    <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Shutters </label>
                        <input type="number" [(ngModel)]="rehabItems.shutters" pInputText />
                      </div>
                    </div>

                    <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Windows </label>
                        <input type="number" [(ngModel)]="rehabItems.windows" pInputText />
                      </div>
                    </div>
                    <div class="col-12 sm:col-6 md:col-4">
                        <div class="input_fields">
                          <label>Exterior Lights </label>
                          <input type="number" [(ngModel)]="rehabItems.exterior_lights" pInputText />
                        </div>
                      </div>
                      <div class="col-12 sm:col-6 md:col-4">
                        <div class="input_fields">
                          <label>Other </label>
                          <input type="number" [(ngModel)]="rehabItems.other_exterior" pInputText />
                        </div>
                      </div>
                    </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Interior (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Interior Stairs </label>
                  <input type="number" [(ngModel)]="rehabItems.interior_stairs" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Railings </label>
                  <input type="number" [(ngModel)]="rehabItems.railings" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Mold Remediation </label>
                  <input type="number" [(ngModel)]="rehabItems.mold_remediation" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Doors - Interior </label>
                  <input type="number" [(ngModel)]="rehabItems.interior_doors" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Doors - Hardware </label>
                    <input type="number" [(ngModel)]="rehabItems.interior_door_hardware" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Carpet </label>
                    <input type="number" [(ngModel)]="rehabItems.carpet" pInputText />
                  </div>
                </div>

                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Vinyl </label>
                    <input type="number" [(ngModel)]="rehabItems.vinyl" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Ceramic </label>
                    <input type="number" [(ngModel)]="rehabItems.ceramic" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Marble </label>
                      <input type="number" [(ngModel)]="rehabItems.marble" pInputText />
                    </div>
                  </div>

                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Hardwood </label>
                      <input type="number" [(ngModel)]="rehabItems.hardwood" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Post Repair Cleaning </label>
                      <input type="number" [(ngModel)]="rehabItems.post_repair_cleaning" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Hot Water Heater </label>
                      <input type="number" [(ngModel)]="rehabItems.hot_water_heater" pInputText />
                    </div>
                  </div>

                  <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Smoke Detectors </label>
                        <input type="number" [(ngModel)]="rehabItems.smoke_detectors" pInputText />
                      </div>
                    </div>
                    <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Carbon Monoxide Detectors </label>
                        <input type="number" [(ngModel)]="rehabItems.carbon_monoxide_detectors" pInputText />
                      </div>
                    </div>
                    <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Smoke/Fire Alarms </label>
                        <input type="number" [(ngModel)]="rehabItems.smoke_fire_alarms" pInputText />
                      </div>
                    </div>

                    <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Sprinkler System Fire Prevention Material </label>
                        <input type="number" [(ngModel)]="rehabItems.sprinkler_fire_prevention" pInputText />
                      </div>
                    </div>
                    <div class="col-12 sm:col-6 md:col-4">
                        <div class="input_fields">
                          <label>Sprinkler System Fire Prevention Labor </label>
                          <input type="number" [(ngModel)]="rehabItems.sprinkler_fire_prevention_labor" pInputText />
                        </div>
                      </div>
                      <div class="col-12 sm:col-6 md:col-4">
                        <div class="input_fields">
                          <label>Paint Walls/Trim </label>
                          <input type="number" [(ngModel)]="rehabItems.paint_walls_trim" pInputText />
                        </div>
                      </div>

                      <div class="col-12 sm:col-6 md:col-4">
                        <div class="input_fields">
                          <label>Light Fixtures </label>
                          <input type="number" [(ngModel)]="rehabItems.light_fixtures" pInputText />
                        </div>
                      </div>
                      <div class="col-12 sm:col-6 md:col-4">
                        <div class="input_fields">
                          <label>Drywall </label>
                          <input type="number" [(ngModel)]="rehabItems.drywall" pInputText />
                        </div>
                      </div>
                      <div class="col-12 sm:col-6 md:col-4">
                          <div class="input_fields">
                            <label>Framing Material </label>
                            <input type="number" [(ngModel)]="rehabItems.framing_material" pInputText />
                          </div>
                        </div>

                        <div class="col-12 sm:col-6 md:col-4">
                          <div class="input_fields">
                            <label>Framing Labor </label>
                            <input type="number" [(ngModel)]="rehabItems.framing_labor" pInputText />
                          </div>
                        </div>
                        <div class="col-12 sm:col-6 md:col-4">
                          <div class="input_fields">
                            <label>Electrical Rough </label>
                            <input type="number" [(ngModel)]="rehabItems.electrical_rough" pInputText />
                          </div>
                        </div>
                        <div class="col-12 sm:col-6 md:col-4">
                          <div class="input_fields">
                            <label>Electrical Finish </label>
                            <input type="number" [(ngModel)]="rehabItems.electrical_finish" pInputText />
                          </div>
                        </div>

                        <div class="col-12 sm:col-6 md:col-4">
                            <div class="input_fields">
                              <label>Electrical Outlets </label>
                              <input type="number" [(ngModel)]="rehabItems.electrical_outlets" pInputText />
                            </div>
                          </div>
                          <div class="col-12 sm:col-6 md:col-4">
                            <div class="input_fields">
                              <label>Electrical Switches </label>
                              <input type="number" [(ngModel)]="rehabItems.electrical_switches" pInputText />
                            </div>
                          </div>
                          <div class="col-12 sm:col-6 md:col-4">
                            <div class="input_fields">
                              <label>Electrical Can Lights </label>
                              <input type="number" [(ngModel)]="rehabItems.electrical_can_lights" pInputText />
                            </div>
                          </div>

                          <div class="col-12 sm:col-6 md:col-4">
                            <div class="input_fields">
                              <label>Sound System In House </label>
                              <input type="number" [(ngModel)]="rehabItems.sound_system_house" pInputText />
                            </div>
                          </div>
                          <div class="col-12 sm:col-6 md:col-4">
                              <div class="input_fields">
                                <label>Security System </label>
                                <input type="number" [(ngModel)]="rehabItems.security_system" pInputText />
                              </div>
                            </div>
                            <div class="col-12 sm:col-6 md:col-4">
                              <div class="input_fields">
                                <label>Vacuum System </label>
                                <input type="number" [(ngModel)]="rehabItems.vacuum_system" pInputText />
                              </div>
                            </div>

                            <div class="col-12 sm:col-6 md:col-4">
                              <div class="input_fields">
                                <label>Fireplace </label>
                                <input type="number" [(ngModel)]="rehabItems.fireplace" pInputText />
                              </div>
                            </div>
                            <div class="col-12 sm:col-6 md:col-4">
                              <div class="input_fields">
                                <label>Plumbing Rough </label>
                                <input type="number" [(ngModel)]="rehabItems.plumbing_rough" pInputText />
                              </div>
                            </div>
                            <div class="col-12 sm:col-6 md:col-4">
                                <div class="input_fields">
                                  <label>Plumbing Finish </label>
                                  <input type="number" [(ngModel)]="rehabItems.plumbing_finish" pInputText />
                                </div>
                              </div>

                              <div class="col-12 sm:col-6 md:col-4">
                                <div class="input_fields">
                                  <label>Sump Pump </label>
                                  <input type="number" [(ngModel)]="rehabItems.sump_pump" pInputText />
                                </div>
                              </div>
                              <div class="col-12 sm:col-6 md:col-4">
                                <div class="input_fields">
                                  <label>Insulation </label>
                                  <input type="number" [(ngModel)]="rehabItems.insulation" pInputText />
                                </div>
                              </div>
                              <div class="col-12 sm:col-6 md:col-4">
                                <div class="input_fields">
                                  <label>HVAC Install Rough </label>
                                  <input type="number" [(ngModel)]="rehabItems.hvac_install_rough" pInputText />
                                </div>
                              </div>

                              <div class="col-12 sm:col-6 md:col-4">
                                  <div class="input_fields">
                                    <label>HVAC Install Finish </label>
                                    <input type="number" [(ngModel)]="rehabItems.hvac_install_finish" pInputText />
                                  </div>
                                </div>
                                <div class="col-12 sm:col-6 md:col-4">
                                  <div class="input_fields">
                                    <label>HVAC 220 Volt </label>
                                    <input type="number" [(ngModel)]="rehabItems.hvac_220_volt" pInputText />
                                  </div>
                                </div>
                                <div class="col-12 sm:col-6 md:col-4">
                                  <div class="input_fields">
                                    <label>Radiant Heating </label>
                                    <input type="number" [(ngModel)]="rehabItems.radiant_heating" pInputText />
                                  </div>
                                </div>

                                <div class="col-12 sm:col-6 md:col-4">
                                  <div class="input_fields">
                                    <label>Smart Systems </label>
                                    <input type="number" [(ngModel)]="rehabItems.smart_systems" pInputText />
                                  </div>
                                </div>
                                <div class="col-12 sm:col-6 md:col-4">
                                    <div class="input_fields">
                                      <label>Other </label>
                                      <input type="number" [(ngModel)]="rehabItems.other_interior" pInputText />
                                    </div>
                                  </div>
                                </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Kitchen (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Ceiling/Wall Repair </label>
                  <input type="number" [(ngModel)]="rehabItems.ceiling_wall_repair" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Fixtures </label>
                  <input type="number" [(ngModel)]="rehabItems.fixtures" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Refridgerator </label>
                  <input type="number" [(ngModel)]="rehabItems.refridgerator" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Dishwasher </label>
                  <input type="number" [(ngModel)]="rehabItems.dishwasher" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Microwave </label>
                    <input type="number" [(ngModel)]="rehabItems.microwave" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Stove </label>
                    <input type="number" [(ngModel)]="rehabItems.stove" pInputText />
                  </div>
                </div>

                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Trash Compactor </label>
                    <input type="number" [(ngModel)]="rehabItems.trash_compactor" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Garbage Disposal </label>
                    <input type="number" [(ngModel)]="rehabItems.garbage_disposal" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Other Appliances </label>
                      <input type="number" [(ngModel)]="rehabItems.other_appliances" pInputText />
                    </div>
                  </div>

                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Cabinets </label>
                      <input type="number" [(ngModel)]="rehabItems.cabinets" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Counters </label>
                      <input type="number" [(ngModel)]="rehabItems.counters" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Sink/Faucet </label>
                      <input type="number" [(ngModel)]="rehabItems.sink_faucet" pInputText />
                    </div>
                  </div>

                    <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Floors </label>
                        <input type="number" [(ngModel)]="rehabItems.floors" pInputText />
                      </div>
                    </div>
                    <div class="col-12 sm:col-6 md:col-4">
                      <div class="input_fields">
                        <label>Other </label>
                        <input type="number" [(ngModel)]="rehabItems.other_kitchen" pInputText />
                      </div>
                    </div>
                  </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Bath 1 (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Bath Tub/Shower </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_1_tub_shower" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Toilet </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_1_toilet" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Vanity & Top </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_1_vanity_top" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Cabinets </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_1_cabinets" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Floors </label>
                    <input type="number" [(ngModel)]="rehabItems.bath_1_floors" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Other </label>
                    <input type="number" [(ngModel)]="rehabItems.bath_1_other" pInputText />
                  </div>
                </div>
              </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Bath 2 (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Bath Tub/Shower </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_2_tub_shower" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Toilet </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_2_toilet" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Vanity & Top </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_2_vanity_top" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Cabinets </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_2_cabinets" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Floors </label>
                    <input type="number" [(ngModel)]="rehabItems.bath_2_floors" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Other </label>
                    <input type="number" [(ngModel)]="rehabItems.bath_2_other" pInputText />
                  </div>
                </div>
              </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Bath 3 (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Bath Tub/Shower </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_3_tub_shower" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Toilet </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_3_toilet" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Vanity & Top </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_3_vanity_top" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Cabinets </label>
                  <input type="number" [(ngModel)]="rehabItems.bath_3_cabinets" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Floors </label>
                    <input type="number" [(ngModel)]="rehabItems.bath_3_floors" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Other </label>
                    <input type="number" [(ngModel)]="rehabItems.bath_3_other" pInputText />
                  </div>
                </div>
              </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="Miscellaneous (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Cabinetry & Labor </label>
                  <input type="number" [(ngModel)]="rehabItems.misc_cabinet_labor" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Washer & Dryer </label>
                  <input type="number" [(ngModel)]="rehabItems.misc_washer_dryer" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Shower Glass </label>
                  <input type="number" [(ngModel)]="rehabItems.misc_shower_glass" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>Iron Works </label>
                  <input type="number" [(ngModel)]="rehabItems.misc_iron_works" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Mirrors </label>
                    <input type="number" [(ngModel)]="rehabItems.misc_mirrors" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>Well & Septic Systems </label>
                    <input type="number" [(ngModel)]="rehabItems.misc_well_septic_system" pInputText />
                  </div>
                </div>

                <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Oil Tank (above or under ground) </label>
                      <input type="number" [(ngModel)]="rehabItems.misc_oil_tank" pInputText />
                    </div>
                  </div>
                  <div class="col-12 sm:col-6 md:col-4">
                    <div class="input_fields">
                      <label>Interior Carpentry/Trim </label>
                      <input type="number" [(ngModel)]="rehabItems.misc_interior_carpentry_trim" pInputText />
                    </div>
                  </div>
                </div>
        </p-accordionTab>
      </p-accordion>

      <p-accordion>
        <p-accordionTab header="General Contractor Fee (Budget Still Needing Allocated {{rehabTotal - totalBudgetAllocated | currency}})" [selected]="false">
          <div class="grid">
            <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>General Contractor Fee-Installment 1 </label>
                  <input type="number" [(ngModel)]="rehabItems.general_contractor_fee_installment_1" pInputText />
                </div>
              </div>
              <div class="col-12 sm:col-6 md:col-4">
                <div class="input_fields">
                  <label>General Contractor Fee-Installment 2 </label>
                  <input type="number" [(ngModel)]="rehabItems.general_contractor_fee_installment_2" pInputText />
                </div>
              </div>

              <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>General Contractor Fee-Installment 3 </label>
                    <input type="number" [(ngModel)]="rehabItems.general_contractor_fee_installment_3" pInputText />
                  </div>
                </div>
                <div class="col-12 sm:col-6 md:col-4">
                  <div class="input_fields">
                    <label>General Contractor Fee-Installment 4 </label>
                    <input type="number" [(ngModel)]="rehabItems.general_contractor_fee_installment_4" pInputText />
                  </div>
                </div>
              </div>
        </p-accordionTab>
      </p-accordion>
</div>
